import { render, staticRenderFns } from "./EmailBottom.vue?vue&type=template&id=1ec2f254&scoped=true"
import script from "./EmailBottom.vue?vue&type=script&lang=js"
export * from "./EmailBottom.vue?vue&type=script&lang=js"
import style0 from "./EmailBottom.vue?vue&type=style&index=0&id=1ec2f254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2f254",
  null
  
)

export default component.exports